import { SaveIntegrationsDocument } from '~/client/graph/operations/generated/LocationType.generated'
import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'

import LocationIntegration from '../../models/LocationObjects/LocationIntegration'
import ILocationDto from '../../types/ILocationDto'
import LocationStoreBase from './LocationBase.store'

export default class LocationIntegrationsStore extends LocationStoreBase<LocationIntegration> {
  protected saveMutation = SaveIntegrationsDocument
  protected graphName = 'integrations'
  protected defaultIconName = MapViewLocationIcon.Monitoring

  public get byId(): Map<string, LocationIntegration> {
    return this.eventsStore.appState.locationIntegrations
  }

  protected fromDto(dto: ILocationDto): LocationIntegration {
    return LocationIntegration.fromDto(dto)
  }
}
